<template>
  <div>
    <div class="indexbanner">
      <ul>
        <li v-for="(item, index) in banners" :key="index">
          <img :src="baseApi + item.image"/>
          <div class="words" :style="{backgroundColor: item.color}">
            <h2>{{item.title}}</h2>
            <label>—— {{item.desc}}</label>
          </div>
        </li>
      </ul>
      <!-- 点切换 -->
      <div class="indexbannerbtn">
      </div>
    </div>
    <div class="indexProduct  clearfix">
      <div class="web">
        <h2 class="firaTitle">经典案例</h2>
        <div class="left fl">
          <img :src="baseApi + 'upload/about/classic.jpg'" />
        </div>
        <div class="right fr">
          <div class="classic" >
            <p>公司拥有一支经验丰富的实施团队，先后承接了多项高速公路机电（强弱电）安装工程:
            </p>
            <ul>
              <li>湖北麻康高速公路麻城东段三系统（收费、监控、通讯系统）</li>
              <li> 湖北枣潜高速襄阳北段高速机电三系统</li>
              <li>湖北宜来高速鹤峰东段高速机电三系统</li>
              <li>湖北宜来高速宣鹤太平隧道机电系统（监控、通风、照明系统）</li>
              <li>宜都至来凤高速公路宜昌段机电工程供配电、照明、通风系统设备安装调试</li>
              <li> 孝汉应高速公路机电工程劳务协作7标段（服务区区域设备安装、调试及土建施工劳务）</li>
            </ul>
          </div>
        </div>
<!--        <div class="left fl">-->
<!--          <div class="commonRotation">-->
<!--            <ul>-->
<!--              <li v-for="(item,index) in goodsLeft" :key="index">-->
<!--                <img :src="baseApi + item.image"/>-->
<!--&lt;!&ndash;                <router-link :to="item.src"> <img :src="baseApi + item.image"/></router-link>&ndash;&gt;-->
<!--              </li>-->
<!--            </ul>-->
<!--            <div class="commonRotationdot"></div>-->
<!--            <span class="commonRotationleft"></span>-->
<!--            <span class="commonRotationright"></span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="right fr">-->
<!--          <div class="Settling">-->
<!--            <ul class="clearfix">-->
<!--              <li v-for="(item,index) in goodsRight" :key="index">-->
<!--                <img :src="baseApi + item.image"/>-->
<!--                <p class="text">{{item.title}}</p>-->
<!--                <div class="linkwuye">-->
<!--&lt;!&ndash;                  <router-link :to="item.src">&ndash;&gt;-->
<!--                    <h4>{{item.title}}</h4>-->
<!--                    <p>{{item.content}}</p>-->
<!--&lt;!&ndash;                  </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                  <router-link :to="item.src" class="more">了解更多</router-link>&ndash;&gt;-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="indexSolution">
      <div class="web">
        <h2 class="firaTitle">施工现场</h2>
        <used-list :data="jindian"  />
<!--        <ul class="clearfix">-->
<!--          <li v-for="(item,index) in jindian" :key="index">-->
<!--            <img :src="baseApi + item.image"/>-->
<!--            <p class="text">{{item.title}}</p>-->
<!--&lt;!&ndash;            <router-link class="Solzhez" :to="item.src">&ndash;&gt;-->
<!--&lt;!&ndash;              <img :src="baseApi + item.image2"  />&ndash;&gt;-->
<!--&lt;!&ndash;            </router-link>&ndash;&gt;-->
<!--          </li>-->
<!--        </ul>-->
      </div>
    </div>
    <div class="indexNewscenter">
      <div class="web clearfix">
        <h2 class="firaTitle">新闻中心</h2>
        <div class="newsleft fl">
          <a :href="newsLeft.src">
            <p> <img :src="baseApi + newsLeft.image"></p>
            <div class="newstext">
              <h4>{{newsLeft.title}}</h4>
              <p>{{newsLeft.content}}</p>
            </div>
          </a>
        </div>
        <div class="newsright fr">
          <div class="lists">
            <dl class="clearfix" v-for="(item,index) in newsRight" :key="index">
              <dd>
                <h2>{{item.num}}</h2>
                <p>{{item.date}}</p>
              </dd>
              <dt>
                <a target="_blank" :href="item.src">
                  <h4>{{item.title}}</h4>
                  <p>{{item.content}}</p>
                </a>
              </dt>
            </dl>
          </div>
          <router-link class="learmore" to="/product">查看更多</router-link>
        </div>
      </div>
    </div>
    <div class="Intorespect">
      <div class="web clearfix">
        <h2 class="firaTitle">走进信悦</h2>
        <div class="left fl">
          <img :src="baseApi + 'upload/about/20200928175430.jpg'" >
        </div>
        <div class="right fr">
          <ul class="clearfix">
            <li>
              <img :src="baseApi + 'webimages/image8.jpg'" alt="公司简介" />
              <p class="liticon">公司简介</p>
              <router-link class="newsSolzhez" to="/overview">
                <h2>公司简介</h2>
                <p>团队 &nbsp;&nbsp; 进取 &nbsp;&nbsp; 拼搏  &nbsp;&nbsp;  务实 &nbsp;&nbsp; 创新 &nbsp;&nbsp;  超越 &nbsp;&nbsp; 共赢</p>
              </router-link>
            </li>
            <li>
              <img :src="baseApi + 'webimages/image9.jpg'" alt="招贤纳士" />
              <p class="liticon">资质证书</p>
              <router-link class="newsSolzhez" to="/honor1">
                <h2>资质证书</h2>
                <p>电子与智能化二级；机电二级；
                  施工劳务序列</p>
              </router-link>
            </li>
            <li>
              <img :src="baseApi + 'webimages/image10.jpg'" alt="联系我们" />
              <p class="liticon">联系我们</p>
              <router-link class="newsSolzhez" to="/contact">
                <h2>联系我们</h2>
                <p>中国 · 安徽</p>
              </router-link>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import UsedList from '@/components/UsedList'
export default {
  components: { UsedList },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/',
      banners: [
        {
          src: '/fhsb',
          title: '智能化集成实施',
          color: '#7d7f8447',
          desc: '高速公路机电（强弱电）工程、智能交通工程、智慧消防工程、智慧水务工程等。',
          image: 'upload/Banner/003.jpg'
        },
        {
          src: '/website',
          title: '自动化系统及驱动产品',
          color: '#27419247',
          desc: '高、中、低压变频器、变频控制柜、软启动器(柜)、高低压三相异步电动机、高低压永磁电机、PLC及伺服控制系统、高低压成套电气开关柜及各类非标控制柜订制、高低压电气元件等。',
          image: 'upload/Banner/002.jpg'
        },
        {
          src: '/channel',
          title: '智慧交通平台研发',
          color: '#7e86a891',
          desc: '高速公路收费系统、视频监控系统、高速公路信息发布、智慧交通管理系统等。',
          image: 'upload/Banner/001.jpg'
        },
        {
          src: '/gis',
          title: '高速公路运维服务',
          color: '#85a1b095',
          desc: '承接全国高速公路机电系统运维、安全设施供货等。',
          image: 'upload/Banner/004.jpg'
        }
      ],
      goodsLeft: [
        {
          src: '/soft',
          image: 'upload/product/20200973304.jpg'
        },
        {
          src: '/server',
          image: 'upload/product/11111.jpg'
        },
        {
          src: '/disign',
          image: 'upload/product/273332.jpg'
        }
      ],
      goodsRight: [
        {
          src: '/fhsb',
          image: 'webimages/image3.jpg',
          title: '智能化集成实施',
          content: '高速公路机电（强弱电）工程、智能交通工程、智慧消防工程、智慧水务工程等。'
        },
        {
          src: '/channel',
          image: 'webimages/image4.jpg',
          title: '智慧交通平台研发',
          content: '高速公路收费系统、视频监控系统、高速公路信息发布、智慧交通管理系统等。'
        },
        {
          src: '/website',
          image: 'webimages/image5.jpg',
          title: '自动化系统及驱动产品',
          content: '高、中、低压变频器、变频控制柜、软启动器(柜)、高低压三相异步电动机、高低压永磁电机、PLC及伺服控制系统、高低压成套电气开关柜及各类非标控制柜订制、高低压电气元件等。'
        },
        {
          src: '/gis',
          image: 'webimages/image2.jpg',
          title: '高速公路运维服务',
          content: '承接全国高速公路机电系统运维、安全设施供货等。'
        }
      ],
      jindian: [
        {
          image: 'upload/product/1.jpg'
        },
        // {
        //   image: 'upload/product/2.jpg'
        // },
        {
          image: 'upload/product/3.jpg'
        },
        {
          image: 'upload/product/4.jpg'
        },
        {
          image: 'upload/product/5.jpg'
        },
        // {
        //   image: 'upload/product/6.jpg'
        // },
        {
          image: 'upload/product/7.jpg'
        },
        {
          image: 'upload/product/8.jpg'
        },
        {
          image: 'upload/product/9.jpg'
        },
        {
          image: 'upload/product/10.jpg'
        },
        {
          image: 'upload/product/11.jpg'
        },
        {
          image: 'upload/product/12.jpg'
        },
        {
          image: 'upload/product/13.jpg'
        },
        {
          image: 'upload/product/14.jpg'
        },
        {
          image: 'upload/product/15.jpg'
        }
      ],
      newsLeft: {
        src: '/#/new1',
        image: 'upload/news/22.jpg',
        title: '【快讯】蔡甸收费站顺利通车，助力智慧高速建设',
        content: ' 2025年6月11日0时，由我司承建机电系统的京港澳高速公路鄂豫界至军山段改扩建项目重点节点——蔡甸收费站（朱家湾收费站），正式通车运营。作为区域交通网络的重要枢纽，该站的启用将显著提升武汉蔡甸区与周边地区的通行能力和智慧交通水平，对优化京港澳高速湖北段整体'
      },
      newsRight: []
    }
  },
  mounted () {
    // ------ banner --------
    const $ = window.$
    if ($('.indexbanner').length > 0) {
      $('.indexbanner').mouseenter(function () {
        $('.leftbtn,.rightbtn').show()
      })
      $('.indexbanner').mouseleave(function () {
        $('.leftbtn,.rightbtn').hide()
      })
      $('.indexbanner ul').cycle({
        fx: 'scrollHorz',
        pager: '.indexbannerbtn',
        speed: 1200,
        timeout: 5000,
        pause: 1,
        prev: '.leftbtn',
        next: '.rightbtn',
        before: function () {
          $('.animatelist').css({ 'position': 'relative', 'opacity': 0, 'top': '60px' })
        },
        after: function () {
          $('.indexbanner li').each(function () {
            var thislist = $(this)
            thislist.find('.animatelist').each(function (i) {
              var sublist = $(this)
              setTimeout(function () {
                sublist.animate({ 'position': 'relative', 'opacity': 1, 'top': '0' }, 500)
              }, (i + 1) * 100)
            })
          })
        }
      })
    }
    // 主营业务左侧
    $('.commonRotation ul').cycle({
      fx: 'scrollHorz',
      speed: 600,
      pager: '.commonRotationdot',
      next: '.commonRotationright',
      prev: '.commonRotationleft'
    })
    this.newsRight = []
    axios({
      method: 'get',
      url: process.env.API_ROOT + 'static/news.json'
    })
      .then(response => {
        console.log(response)
        for (let i = 1; i < 4; i++) {
          const item = response.data[i]
          this.newsRight.push({
            src: item.src,
            num: item.date.split('.')[2],
            date: item.month,
            title: item.title,
            content: item.content
          })
        }
      }).catch(reason => {
        console.log(reason)
      })
    $('.indexSolution ul').each(function () {
      var n = $(this).find('li').length
      $(this).find('li').eq(n - 1).css({'margin-right': '0'})
    })
    $('.Intorespect .right li').eq(0).css({'width': '576px', 'height': '211px;', 'margin-right': '0', 'margin-bottom': '10px'})
    $('.Intorespect .right li').eq(0).find('img').css({'width': '576px', 'height': '211px;'})
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue